const VISIT_ROW_COUNT = 12;

export function formatCardDate(value, formatDate) {
  if (!value) return '';
  if (typeof formatDate === 'function') {
    const formatted = formatDate(value);
    return formatted === '-' ? '' : formatted;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('fr-FR');
}

export function blankLine(value, minChars = 28) {
  const text = value != null && String(value).trim() !== '' ? String(value).trim() : '';
  return text || '\u00a0'.repeat(minChars);
}

export function formatCardTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

export function computeCardValidity(member, formatDate) {
  const start = member?.date_embauche;
  if (!start) return { from: '', to: '' };
  const fromDate = new Date(start);
  if (Number.isNaN(fromDate.getTime())) return { from: '', to: '' };
  const toDate = new Date(fromDate);
  toDate.setFullYear(toDate.getFullYear() + 1);
  toDate.setDate(toDate.getDate() - 1);
  return {
    from: formatCardDate(start, formatDate),
    to: formatCardDate(toDate.toISOString(), formatDate)
  };
}

export function resolveMemberTypeMark(type) {
  const t = String(type || '').toUpperCase();
  if (t === 'AGENT') return 'A';
  if (t === 'CONJOINT' || t === 'CONJOINTE') return 'C';
  if (t === 'ENFANT') return 'E';
  return null;
}

export function resolveAgentName(member) {
  if (!member) return '';
  if (String(member.type || '').toUpperCase() === 'AGENT') {
    return '';
  }
  const parts = [member.agent_prenom, member.agent_nom].filter(Boolean);
  if (parts.length) return parts.join(' ');
  if (member.agent_matricule) return `Matricule ${member.agent_matricule}`;
  return '';
}

export function resolveCompanyMeta(member, companies = [], getCompanyName) {
  const company =
    companies.find((c) => Number(c.id) === Number(member?.company_id)) || null;
  const name =
    member?.company_name ||
    company?.name ||
    (typeof getCompanyName === 'function' ? getCompanyName(member?.company_id) : '') ||
    '';
  return {
    name: name === '-' ? '' : name,
    code: company?.company_code || '',
    address: company?.address || '',
    city: company?.city || company?.affiliation_city || '',
    postalCode: company?.postal_code || ''
  };
}

export function buildVisitRows(visits = [], formatDate) {
  const sorted = [...visits].sort(
    (a, b) => new Date(a.registered_at) - new Date(b.registered_at)
  );
  const rows = sorted.slice(-VISIT_ROW_COUNT).map((visit) => ({
    date: formatCardDate(visit.registered_at, formatDate),
    place:
      visit.visit_site_name ||
      visit.consultation_site_name ||
      visit.company_name ||
      '',
    entry: formatCardTime(visit.registered_at),
    exit:
      visit.status === 'ORIENTED' && visit.updated_at
        ? formatCardTime(visit.updated_at)
        : ''
  }));
  while (rows.length < VISIT_ROW_COUNT) {
    rows.push({ date: '', place: '', entry: '', exit: '' });
  }
  return rows;
}

export { VISIT_ROW_COUNT };
